export default __webpack_public_path__ + "static/media/set_5_Page-4.7e4cb071.svg";